import {
    GET_CONSIGNMENTRETURN_DETAILS,
    GET_CONSIGNMENTRETURN_DETAILS_SUCCESS,
    GET_CONSIGNMENTRETURN_DETAILS_FAILURE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    consignmentDetails: {
        myCaseRef: '',
    },
    myCaseRefId: null,
    myCaseResourceType: null,
    isdeletionDone: false,
    isUsageAttachmentUploaded: false,
    poTissueImageDetails: '',
    poNonTissueImageDetails: '',
    poImagePreviewLoader: false,
    poImagePreviewDetails: null,
    poImageUploadLoader: false,
};

const consignmentReturnDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONSIGNMENTRETURN_DETAILS:
            return {
                ...state,
                ...initialState,
                // myCaseRef: action.myCaseRef,
            };
        case GET_CONSIGNMENTRETURN_DETAILS_SUCCESS:
            return {
                ...state,
                consignmentDetails: {
                    myCaseRef: action.myCaseRef,
                },
            };
        case GET_CONSIGNMENTRETURN_DETAILS_FAILURE:
            return {
                ...state,
                consignmentDetails: {
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentReturnDetailsKey',
        storage: storage,
    },
    consignmentReturnDetailsReducer
);
